import {getTimeoutPopup, checkUserInterests, createCSData} from "../scripts/article/additionaldata-script";

Voonto.getInstance().define(['module'], function (module) {
    const app = Voonto.getInstance();
    const Logger = nibara.logger;

    var baseurl = '/ajax/v2/api/v1/';

    function handleResponse(response)
    {
        var $elm = $(this);
        var btn = $elm.data('btn');
        var sec = $elm.data('sec');
        var stat = $elm.data('stat');
        var isTrue = false;
        Logger.debug('starred module response ' + btn + ' - ' + sec + ': ', response);
        if (response && 'undefined' !== typeof response.code && response.code === 200) {
            var timeout = getTimeoutPopup(btn);
            if (btn === 'following') {
                if (response.following === true) {
                    isTrue = true;
                    if(sec === 'summum') {
                        $elm.data('active', true).attr('data-voc-vtm-id', 'btn-noseguirautor').addClass('activo')
                            .find('.accion').text('Siguiendo');
                    }else if(sec === 'bienestar') {
                        $(this).data('active', true).attr('data-voc-vtm-id', 'btn-noseguirautor').addClass('activo')
                            .find('.accion').text('Siguiendo');
                    }else{
                        $elm.data('active', true).attr('data-voc-vtm-id', 'btn-noseguirautor')
                            .find('input').attr('checked',true);
                        $elm.data('active', true).attr('data-voc-vtm-id', 'btn-noseguirautor')
                        .find('a').addClass('activo');
                        $elm.data('active', true).attr('data-voc-vtm-id', 'btn-noseguirautor')
                        .find('a').text('Siguiendo');
                        $elm.data('active', true).find('label').attr('title', function(index, title) {
                            return title.replace('Seguir','Dejar de seguir')
                        });
                    }
                } else {
                    if(sec === 'summum') {
                        $elm.data('active', false).attr('data-voc-vtm-id', 'btn-seguirautor').removeClass('activo')
                            .find('.accion').text('Seguir');
                    }else if(sec === 'bienestar') {
                        $(this).data('active', false).attr('data-voc-vtm-id', 'btn-seguirautor').removeClass('activo')
                            .find('.accion').text('Seguir');
                    }else{
                        $elm.data('active', false).attr('data-voc-vtm-id', 'btn-seguirautor')
                            .find('input').attr('checked',false);
                        $elm.data('active', true).attr('data-voc-vtm-id', 'btn-seguirautor')
                        .find('a').removeClass('activo');
                        $elm.data('active', true).attr('data-voc-vtm-id', 'btn-seguirautor')
                        .find('a').text('Seguir');
                        $elm.data('active', false).find('label').attr('title', function(index, title) {
                            return title.replace('Dejar de seguir','Seguir')
                        });
                    }
                }
            }
            else if (btn === 'starred') {
                if (response.starred === true) {
                    isTrue = true;
                    $elm.data('active', true).addClass('activo');
                    $elm.parent().addClass('activo');
                    if('undefined' === typeof sec ){
                        $elm.html('<span class="icono leer-despues">' +
                            '<svg viewBox="0 0 24 24"><path d="M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z"></path></svg>' +
                            '</span>Guardado');
                    }else if(sec === 'bienestar'){
                        $elm.find('span.accion').text('Guardado');
                    }
                } else {
                    $elm.data('active', false).removeClass('activo');
                    $elm.parent().removeClass('activo');
                    if('undefined' === typeof sec ){
                        $elm.html('<span class="icono leer-despues">' +
                            '<svg viewBox="0 0 24 24"><path d="M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z"></path></svg>' +
                            '</span>Guardar');
                    }else if(sec === 'bienestar'){
                        $elm.find('span.accion').text('Guardar');
                    }
                }
            }

           if (isTrue && ('undefined' !== typeof response.updated) && (response.updated === true)){
               app.when('vocuser:ready').then(function (gigyaUX) {
                   var csData = createCSData($elm);
                   gigyaUX.sendCustomerService(csData.serviceId, csData.serviceReference).done(function (response) {
                       setTimeout(function () {
                           if (!document.cookie.match(/^(.*;)?\s*check_interests\s*=\s*[^;]+(.*)?$/)){
                               checkUserInterests($elm,baseurl);
                           }
                       }, timeout);
                   });
               });
           }
           $elm.one('click', handleClick);
        }
    }

    function handleClick(ev)
    {
        var $elm = $(this);
        var btn = $elm.data('btn');
        var active = $elm.data('active');

        var fields = {
            "id": $elm.data('id'),
            "type": $elm.data('type'),
        };
        fields[btn] = !active;
        var content = {};
        content[btn] = fields;

        Logger.debug('starred update ' + btn + ' ', JSON.stringify(content));
        $.ajax({
            type: 'post',
            url: baseurl + btn + '/update',
            data: content,
            dataType: 'json',
            context: $elm,
            timeout: 10000
        }).fail(function(jqXHR, textStatus, errorThrown){
            Logger.error('starred module update ' + btn + ' error: ', textStatus);
        }).done(handleResponse);

    }

    function starred($elm)
    {
        var btn = $elm.data('btn');
        var tipo = $elm.data('type');
        var id = $elm.data('id');
        Logger.info(`starred module ${btn} ${tipo} ${id}`);
        if (btn === 'starred' || btn === 'following') {
            Voonto.$.ajax({
                url: baseurl + btn + '/' + tipo + '/' + id,
                dataType: 'json',
                context: $elm,
                timeout: 10000
            }).fail(function(jqXHR, textStatus, errorThrown) {
                Logger.error('starred module: retrieve ' + btn + ' error ', textStatus);
            }).done(handleResponse);
        }
    }

    return {
        wakeUp($elm){
            Logger.info(`wake up module ${module.id}`);

            var starredUrl = app.lookup('vocento.config.nibara').starredUrl;
            if (starredUrl !== undefined) {
                baseurl = starredUrl + '/';
            }

            app.when('vocuser:ready').then(function(gigyaUX) {
                Logger.debug('[vocuser-ready] gigyaUX',gigyaUX);
                app.when('vocuser:getusertype').then(function(response) {
                    var btn = $elm.data('btn');
                    var id = $elm.data('id');
                    var valC = btn + '=' + id;
                    var userType = response['responseGetUserType'];
                    var csData = createCSData($elm);
                    if (userType !== 'anonimo') {
                        var urlReferer = document.referrer;
                        if (urlReferer.indexOf("login/login.html") > -1){
                            if (document.cookie.match(/^(.*;)?\s*cookie_voc_check_cs\s*=\s*[^;]+(.*)?$/)){
                                var contentCookie = window.nibara.nTools.getContentCookie('cookie_voc_check_cs');
                                if (contentCookie == valC){
                                    gigyaUX.sendCustomerService(csData.serviceId, csData.serviceReference).done(function () {
                                        window.nibara.nTools.removeCookieByName('cookie_voc_check_cs', btn, 3600000);
                                    });
                                }
                            }
                        }
                        starred($elm);
                    } else {
                        $elm.one('click', function() {
                            window.nibara.nTools.createCookieByName('cookie_voc_check_cs', valC, 3600000);
                            gigyaUX.updateCustomerServiceInCookieVocUser(csData.serviceId, csData.serviceReference);
                            gigyaUX.showLogin();
                        });
                    }
                });
            });
        }
    }
});



// WEBPACK FOOTER //
// ./src/modules/starred-module.js